import React, {Component} from 'react';
import Intestazione from './components_novel/intestazione';
import Piedone from './components/piedone';
import Navbar from './components/navbar';
import Seo, {siteUrl} from './components/seo';
import {getArticlePath, getCreativeArticlesByPublishDate} from './data/creativeArticles';
import pillarPages from './data/pillarPages';

import logo from './images/Logo-Verso-Hemelslinn-2.webp';
import intestazioneBackgroundImage from './images/verso-hemelslinn-sfondo-2.webp';

const intestazioneBackgroundStyle = {
  backgroundImage: `url(${intestazioneBackgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundAttachment: 'fixed',
  height: '300px',
};

export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary.startsWith('/') ? urlOfTheLibrary : '/' + urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}

class Articles extends Component {
  state = {
    aNavbarLinks: [
      {id: 0, linkHref: '/', linkNome: 'ROMANZO'},
      {id: 1, linkHref: '/summary', linkNome: 'SOMMARIO'},
    ],
  };

  render() {
    const articlesByPublishDate = getCreativeArticlesByPublishDate();
    const archiveJsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          '@id': `${siteUrl}/articoli#webpage`,
          url: `${siteUrl}/articoli`,
          name: 'Articoli e percorsi editoriali',
          description:
            'Archivio degli articoli di Verso Hemelslinn: scrittura, personaggi, worldbuilding, relazioni e produzione editoriale.',
          isPartOf: {
            '@id': `${siteUrl}/#website`,
          },
          about: {
            '@id': `${siteUrl}/#book`,
          },
          inLanguage: 'it-IT',
        },
        {
          '@type': 'BreadcrumbList',
          '@id': `${siteUrl}/articoli#breadcrumb`,
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'Verso Hemelslinn',
              item: `${siteUrl}/`,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Articoli',
              item: `${siteUrl}/articoli`,
            },
          ],
        },
      ],
    };

    return (
      <>
        <div className="page">
          <Seo
            title="Articoli e percorsi editoriali"
            description="Archivio degli articoli di Verso Hemelslinn: scrittura, personaggi, worldbuilding, relazioni, ebook e produzione editoriale."
            path="/articoli"
            image="/images/copertina-verso-hemelslinn.webp"
            jsonLd={archiveJsonLd}
          />
          <Navbar
            linkSito="/"
            logo={logo}
            deskLogo="Logo di Verso Hemelslinn"
            brandName="Verso Hemelslinn"
            aNavbarLinks={this.state.aNavbarLinks}
          />
          <div id="pagina">
            <Intestazione
              pagina="ARTICOLI"
              backgroundStyle={intestazioneBackgroundStyle}
              titolo="SCRITTURA CREATIVA"
              titoloAs="p"
              romanzo="il laboratorio narrativo di"
              autore="VERSO HEMELSLINN"
            />

            <section className="ftco-section creative-archive-section">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-9 heading-section text-center mb-5">
                    <p className="landing-kicker">Archivio</p>
                    <h1>Articoli e percorsi editoriali di Verso Hemelslinn</h1>
                    <p>
                      Cinque percorsi per esplorare il laboratorio del romanzo: tecnica narrativa, personaggi, mondi, relazioni e produzione editoriale.
                    </p>
                  </div>
                </div>

                <div className="seo-pillar-grid article-path-grid">
                  {pillarPages.map((page) => (
                    <article className="seo-pillar-card" key={page.slug}>
                      <h3>
                        <a href={page.path}>{page.title}</a>
                      </h3>
                      <p>{page.description}</p>
                      <a className="creative-text-link" href={page.path}>
                        Esplora il percorso
                      </a>
                    </article>
                  ))}
                </div>

                <div className="row justify-content-center mt-5">
                  <div className="col-md-9 heading-section text-center mb-4">
                    <h2>Articoli pubblicati sulla scrittura di Verso Hemelslinn</h2>
                  </div>
                </div>

                <div className="creative-archive-grid">
                  {articlesByPublishDate.map((article) => (
                    <article className="creative-archive-card" key={article.id}>
                      <a href={getArticlePath(article)} className="creative-archive-image">
                        <img
                          src={article.cover}
                          alt={article.coverAlt}
                          style={{objectPosition: article.coverPosition || 'center center'}}
                        />
                      </a>
                      <div className="creative-archive-body">
                        <p className="creative-meta">
                          {article.date} · {article.readingTime}
                        </p>
                        <h3>
                          <a href={getArticlePath(article)}>{article.title}</a>
                        </h3>
                        <p>{article.subtitle}</p>
                        <a className="creative-text-link" href={getArticlePath(article)}>
                          Leggi l’articolo
                        </a>
                      </div>
                    </article>
                  ))}
                </div>
                <section className="seo-pillar-faq" aria-labelledby="articles-faq-title">
                  <h2 id="articles-faq-title">Domande frequenti</h2>
                  <details open>
                    <summary>Da dove conviene iniziare?</summary>
                    <p>Puoi partire dai percorsi tematici, scegliere un articolo recente o leggere il <a href="/summary">sommario</a> del romanzo.</p>
                  </details>
                  <details>
                    <summary>Gli articoli sono collegati a Verso Hemelslinn?</summary>
                    <p>Si. Gli articoli nascono dal laboratorio narrativo del romanzo e approfondiscono scrittura, personaggi, worldbuilding, relazioni ed editoria digitale.</p>
                  </details>
                  <details>
                    <summary>Dove posso seguire il progetto editoriale?</summary>
                    <p>Puoi seguire la <a href="https://hemelslinn.s.gy/vh-web-hem-land">campagna crowdfunding</a> e tornare all'archivio per i nuovi articoli.</p>
                  </details>
                </section>
              </div>
            </section>

            <Piedone
              piedoneCallToAction="Ogni storia ha una rotta visibile e una rotta nascosta. Qui comincia il laboratorio."
              piedoneLinkTermConditions=""
              piedoneLinkCookies="/cookies"
              piedoneLinkPrivacy="/privacy"
              piedoneIframe=""
              piedoneTwitter="https://x.com/Hemelslinn"
              piedoneInstagram="https://www.instagram.com/versohemelslinn/"
              piedoneFacebook="https://www.facebook.com/hemelslinn"
              piedoneTiktok="https://www.tiktok.com/@hemelslinn"
              piedoneDiscord=""
              piedonePinterest="https://it.pinterest.com/hemelslinn/"
              piedoneOpensea=""
              piedoneEliosfera="https://www.eliosfera.it/maurizio-feruglio-verso-hemelslinn-copertina-rigida-libro"
              piedoneYoutube="https://www.youtube.com/@VersoHemelslinn"
              piedoneCopyright="Eliosfera Editrice &copy;"
              piedoneCopyrightDisclaimer="Tutti i diritti riservati"
              piedoneCCBY='Template basato su <i class="icon-heart" aria-hidden="true"></i> <a href="https://colorlib.com" target="_blank">Colorlib</a>'
            />
          </div>

          {AddLibrary('js/jquery.min.js')}
          {AddLibrary('js/jquery-migrate-3.0.1.min.js')}
          {AddLibrary('js/jquery.waypoints.min.js')}
          {AddLibrary('js/jquery.stellar.min.js')}
          {AddLibrary('js/owl.carousel.min.js')}
          {AddLibrary('js/aos.js')}
          {AddLibrary('js/scrollax.min.js')}
          {AddLibrary('js/main.js')}
        </div>
      </>
    );
  }
}

export default Articles;
